// The status a failed API call came back with; none when it got no response.
export const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } })?.response?.status;
